var $ = global.jQuery = global.$;
var widgets = require('../lib/widgets');

var _Base = require('./_Base');

function getIcon(classList) {
  var split = classList.split(' '),
      iconClass;

  for(var i=0;i<split.length;i++) {
    if (split[i].indexOf('icon--') + 1) iconClass = split[i];
  }

  return iconClass;
}

var Icon = _Base.extend({
  init: function(el, opts) {
    opts = opts ? opts : {};
    var self = this,
        $icon = this.$el.find('.icon');

    this.startIcon = $icon.length ? getIcon($icon.attr('class')) || opts.startIcon : opts.startIcon;
    this.toggleIcon = opts.toggleIcon;

    this.$el.html('<span class="icon icon--' + this.startIcon + '"><span class="inner1"></span><span class="inner2"></span><span class="inner3"></span></span>');

    this.$icon = this.$el.find('.icon');
  },
  toggle: function() {
    if (getIcon(this.$icon.attr('class')) === this.startIcon) {
      this.change(this.toggleIcon);
    } else {
      this.change(this.startIcon);
    }
  },
  change: function(icon) {
    this.$icon.attr('class','icon icon--' + icon);
  }
});

module.exports = Icon;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/Icon.js
// module id = 273
// module chunks = 0